"use client";

import Image from "next/image";
import WaitListButton from "@/components/waitlist-button";

import BoxReveal from "@cohub42/ui/components/magicui/box-reveal";
import { BackgroundBeams } from "@cohub42/ui/components/ui/background-beams";
import { Card, CardContent } from "@cohub42/ui/components/ui/card";

const keyBenefits = [
  "AI matching based on role, skills, and location",
  "Real-time messaging with matched co-founders",
  "Discover meetups & networking events near you",
  "24/7 AI-powered startup mentor & advisor",
];

export default function AiAssistantSection() {
  return (
    <section className="relative w-full overflow-hidden py-16 sm:py-24">
      <BackgroundBeams className="absolute inset-0 opacity-20" />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <BoxReveal boxColor="transparent" duration={0.5} width="100%">
            <div className="mb-4 inline-flex items-center rounded-full bg-gradient-to-r from-purple-100 to-blue-100 px-4 py-1.5 text-sm font-medium text-purple-800 ring-1 ring-purple-200 dark:from-purple-900/30 dark:to-blue-900/30 dark:text-purple-300 dark:ring-purple-800">
              🤖 AI-Powered Platform
            </div>
          </BoxReveal>

          <BoxReveal boxColor="transparent" duration={0.5} width="100%">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-4xl">
              AI That Finds Your{" "}
              <span className="text-primary">Perfect Match</span>
            </h2>
          </BoxReveal>

          <BoxReveal boxColor="transparent" duration={0.5} width="100%">
            <p className="mt-4 text-base leading-7 text-gray-600 dark:text-gray-300">
              Advanced AI that understands vision, values, and complementary
              strengths.
            </p>
          </BoxReveal>
        </div>

        <div className="mx-auto mt-12 grid max-w-5xl grid-cols-1 gap-8 lg:grid-cols-2">
          <BoxReveal boxColor="transparent" duration={0.5} width="100%">
            <Card className="overflow-hidden border-0 bg-white shadow-lg dark:bg-gray-800">
              <CardContent className="p-4">
                <div className="relative aspect-[4/3] overflow-hidden rounded-lg">
                  <Image
                    src="/images/uae-bot.png"
                    alt="AI Co-Founder Assistant"
                    width={600}
                    height={450}
                    className="h-full w-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                  <div className="absolute bottom-3 left-3 right-3">
                    <div className="rounded-lg bg-white/90 p-2.5 backdrop-blur-sm dark:bg-gray-900/90">
                      <p className="text-sm font-medium text-gray-900 dark:text-white">
                        "Found 3 co-founders matching your profile..."
                      </p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </BoxReveal>

          <div className="flex h-full flex-col justify-center space-y-6">
            <BoxReveal boxColor="transparent" duration={0.6} width="100%">
              <div className="flex h-full flex-col justify-center space-y-6">
                <div className="space-y-3">
                  {keyBenefits.map((item, index) => (
                    <div key={index} className="flex items-center gap-3">
                      <div className="flex-shrink-0 rounded-full bg-green-100 p-1 dark:bg-green-900">
                        <div className="h-2 w-2 rounded-full bg-green-500" />
                      </div>
                      <p className="text-sm text-gray-700 dark:text-gray-300">
                        {item}
                      </p>
                    </div>
                  ))}
                </div>

                <WaitListButton />
              </div>
            </BoxReveal>
          </div>
        </div>
      </div>
    </section>
  );
}
